import { ReactElement } from 'react'
import styled from 'styled-components'
import Table from 'react-bootstrap/Table'
import { Row, Col } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { CompletedSessionTableProps } from './typing'
import TableHeader, { TableWrapper } from '../../../components/TableHeader'

interface CompletedSessionWrapperProps {
  isMenuOpen: boolean
}

export const CompletedSessionWrapper = styled.div<CompletedSessionWrapperProps>`
  width: 100%;
  padding: 1.5rem 0;
  @media (max-width: 415px) {
    z-index: ${({ isMenuOpen }) => (isMenuOpen ? '-1' : '0')};
  }
`

export const HeaderRow = styled(Row)`
  width: 100%;
  display: flex;
  flex-direction: row;
`

export const TableRow = styled(Row)`
  margin: 0 3rem;

  @media (max-width: 1024px) {
    margin: 0;
  }
`

export const DropdownCol = styled(Col)`
  display: flex;
  align-items: center;
  @media (max-width: 656px) {
    margin-bottom: 2rem;
  }
`

interface IconWrapperProps {
  isDisabled: boolean
}

const IconWrapper = styled(FontAwesomeIcon)<IconWrapperProps>`
  margin-left: 20%;
  ${({ isDisabled }) =>
    isDisabled
      ? 'cursor: not-allowed; opacity: 0.6;'
      : 'cursor: pointer; opacity: 1;'}
`

export const CompletedSessionTable = ({
  tableHeader,
  completedSessions
}: CompletedSessionTableProps): ReactElement => {
  return (
    <TableWrapper>
      <Table size="sm" responsive="sm">
        <TableHeader>
          <tr>
            {tableHeader?.map((header, index) => (
              <th key={`completed-session-header-${index}`}>{header}</th>
            ))}
          </tr>
        </TableHeader>
        <tbody>
          {completedSessions?.map((session, index) => (
            <tr key={`completed-session-${index}`}>
              <td>{session.name}</td>
              <td>{session.facultyName}</td>
              <td>{session.date}</td>
              <td>{session.time}</td>
              <td>{session.duration}</td>
              <td>
                <IconWrapper
                  isDisabled={!session.url}
                  onClick={() => {
                    session.url && window.open(session.url, '_blank')
                  }}
                  icon={['fas', 'play-circle']}
                  size="2x"
                />
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </TableWrapper>
  )
}
